import { logoutUser } from 'api-client';
import { useEffect, type JSX } from 'react';
import { clearUserData } from 'utils/clearUserData';

function Logout(): JSX.Element {
  useEffect(() => {
    sessionStorage.clear();
    void clearUserData();
    logoutUser();
  }, []);

  return <div />;
}

export default Logout;
